import React from 'react'
import SVG from 'react-inlinesvg'
import { toAbsoluteUrl } from '../AssetHelpers'
type Props = {
  className?: string
  path: string
  svgClassName?: string
  textColor?: string
}

const KTSVG: React.FC<Props> = ({
  className = '',
  path,
  svgClassName = 'mh-50px',
  textColor = '',
}) => {
  return (
    <span className={`svg-icon ${className}`}>
      {textColor === '' ? (
        <SVG src={toAbsoluteUrl(path)} className={svgClassName} />
      ) : (
        <SVG src={toAbsoluteUrl(path)} className={svgClassName} style={{ color: textColor }} />
      )}
    </span>
  )
}

export { KTSVG }
